// should be changed together with modules/catalog/assets/index.scss:34 media query
export const mobileViewMaxWidth = 1340;
